import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector, RootState } from 'store';
import { getEmployeeIdByUpn } from 'store/Auth';
import { ApiResponseStatus } from 'models/enums';

export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function useCurrentEmployeeId() {
  const dispatch = useAppDispatch();
  const { employeeId, employeeIdStatus, employeeIdError, user } = useAppSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (user.isAuthenticated && user.authData?.token && !employeeId && employeeIdStatus !== ApiResponseStatus.pending) {
      dispatch(getEmployeeIdByUpn());
    }
  }, [dispatch, user.isAuthenticated, user.authData?.token, employeeId, employeeIdStatus]);

  return {
    employeeId,
    isLoading: employeeIdStatus === ApiResponseStatus.pending,
    error: employeeIdError,
    status: employeeIdStatus
  };
}
